import React, { useState } from "react";
import "./checkBoxDownHL.css";
/**
 * @typedef {object} PropsCustom
 * @property {string} labelCheckBox - Label for the checkbox
 * @property {boolean} valueCheckBox - Initial value for the checkbox
 * @property {function} onChangeHandler - Function to call when the checkbox is clicked
 * @property {boolean} checkedState - Current checked state of the checkbox
 * @property {string|number} idCheckBox - ID for the checkbox input
 */

/** 
* @typedef {Omit<import('react').ButtonHTMLAttributes<HTMLInputElement>, 'children'> & PropsCustom} Props
*/

/**
 * @param {Props}
 */
const CheckBoxDownHLPure = ({
    labelCheckBox,
    valueCheckBox,
    idCheckBox,
    onChangeHandler,
    checkedState,
    ...props
}) => {
    const [valueCheck, setValueCheck] = useState(valueCheckBox || false);
    const handleChange = (event) => {
        setValueCheck(event.target.checked);
    };

    return (
        <div
            item
            xs={12}
            lg={12}
            md={12}
            sm={12}
            className="CheckBoxDownHLPure-container"
        >
            <label
                className="CheckBoxDownHLPure-label"
                htmlFor={idCheckBox}
                onClick={(e) => e.stopPropagation()}
            >
                <input
                    type="checkbox"
                    className="CheckBoxDownHLPure-input"
                    {...props}
                    id={idCheckBox}
                    name={labelCheckBox}
                    value={valueCheck}
                    checked={checkedState}
                    onClick={onChangeHandler ? onChangeHandler : handleChange}
                />
                <div className="CheckBoxDownHLPure-label-text">{labelCheckBox}</div>
            </label>

        </div>
    );
};

export { CheckBoxDownHLPure as default };
